import React from "react";
import { FormHost, FormHostParameters, IFormHost } from "../../rule-engine-core/Common/Execution/IFormHost";
import { UILayer } from "../../CommonUI/BuildlingBlocks/UILayer";
import { Box } from "@mui/material";
import { UIStandardLayer } from "../../CommonUI/BuildlingBlocks/UIStandardLayer";
import { UILabel } from "../../CommonUI/BuildlingBlocks/UILabel";
import { AutoBind } from "../../rule-engine-core/Common/AutoBind";

class FormStack {
    forms: FormHostParameters[] = [];

    removeForm(renderId: string) {
        this.forms = this.forms.filter((f) => {
            return f.renderId !== renderId;
        });
    }
}

export class UILayerFormHost
    extends React.Component<
        {},
        {
            formStack: FormStack;
            confirmClose: boolean;
        }
    >
    implements IFormHost
{
    constructor(props: {}) {
        super(props);
        this.state = {
            confirmClose: false,
            formStack: new FormStack(),
        };
        FormHost.defaultFormHost = this;
    }

    renderUI(formData: FormHostParameters): void {
        let forms = this.state.formStack;
        forms.forms.push(formData);
        this.setState({ formStack: forms });
    }

    close(renderId: string): void {
        this.state.formStack.removeForm(renderId);
        this.setState({ formStack: this.state.formStack });
    }

    render() {
        if (this.state.formStack.forms.length !== 0) {
            let form = this.state.formStack.forms[this.state.formStack.forms.length - 1];

            return (
                <>
                    <UILayer
                        showCloseButton={form.showCloseButton}
                        renderUI={() => {
                            // todo: add 'in process' and 'assigned' form list
                            return (
                                <Box
                                    width={form.size?.width ?? "800px"}
                                    height={form.size?.height ?? "800px"}
                                >
                                    {form.renderUI()}
                                </Box>
                            );
                        }}
                        open={this.state.formStack.forms.length !== 0}
                        onClose={() => {
                            this.setState({ confirmClose: true });
                        }}
                    />
                    {this.state.confirmClose && <this.RenderConfirmClose renderId={form.renderId} />}
                </>
            );
        }

        return <></>;
    }

    @AutoBind
    RenderConfirmClose(props: { renderId: string }) {
        return (
            <UIStandardLayer
                renderUI={() => {
                    return <UILabel>Do you want to close this form without saving?</UILabel>;
                }}
                open={this.state.confirmClose}
                title={"Close Form?"}
                primaryActionText={"Cancel"}
                onPrimaryAction={() => {
                    this.setState({ confirmClose: false });
                }}
                secondaryActionText={"Close Form"}
                onSecondaryAction={() => {
                    this.setState({ confirmClose: false });
                    this.close(props.renderId);
                    // todo: save as assignment
                }}
            ></UIStandardLayer>
        );
    }
}
